import sanitizeHtml from './sanitizeHtml';

export default html => ({ __html: sanitizeHtml(html) });
